// Wait for DOM ready
document.addEventListener("DOMContentLoaded", () => {
  // Check if any .Bundle-Offer exists (only then run the rest)
  const bundleOffers = document.querySelectorAll('.Bundle-Offer');
  if (!bundleOffers || bundleOffers.length === 0) return; // nothing to do

  // Insert timer badge after each .card__badge (if not already present)
  function insertTimerBadge() {
    const badges = document.querySelectorAll(".card__badge");
    if (!badges || badges.length === 0) return;

    badges.forEach((badge) => {
      // Avoid duplicates
      const next = badge.nextElementSibling;
      if (next && next.classList && next.classList.contains("timer-badge")) return;

      const timerDiv = document.createElement("div");
      timerDiv.classList.add("timer-badge");
      timerDiv.innerHTML = `
        <svg class="timer-badge-icon" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 8a1 1 0 011 1v4l3 1a1 1 0 11-.5 1.94l-3.5-1.17A1 1 0 0111 14V9a1 1 0 011-1zm0-6a10 10 0 1010 10A10 10 0 0012 2zm0 18a8 8 0 118-8 8 8 0 01-8 8z"/>
        </svg>
        <span class="timer-text">00:00:00</span>
      `;
      badge.insertAdjacentElement("afterend", timerDiv);
    });
  }

  // Get current time in IST (UTC +5:30)
  function nowInIST() {
    const now = new Date();
    const utcMs = now.getTime() + now.getTimezoneOffset() * 60000; // local -> UTC
    const istOffsetMs = (5 * 60 + 30) * 60 * 1000; // +5:30 hours in ms
    return new Date(utcMs + istOffsetMs);
  }

  // Remaining ms until next IST midnight (00:00 of next day)
  function getRemainingToMidnightIST() {
    const istNow = nowInIST();
    const midnight = new Date(istNow);
    midnight.setHours(24, 0, 0, 0); // next day's 00:00:00 IST
    const diff = midnight.getTime() - istNow.getTime();
    return diff > 0 ? diff : 0;
  }

  // Format milliseconds to HH:MM:SS
  function formatTime(ms) {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (n) => n.toString().padStart(2, "0");
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  // Update all timer elements
  function updateTimers() {
    const remaining = getRemainingToMidnightIST();
    const text = formatTime(remaining);
    document.querySelectorAll(".timer-text").forEach((el) => {
      el.textContent = text;
    });
  }

  // Initialize
  insertTimerBadge();
  updateTimers();

  // Single interval for updates (clear any previous if needed)
  const existingInterval = window.__bundleTimerIntervalId;
  if (existingInterval) {
    clearInterval(existingInterval);
  }
  window.__bundleTimerIntervalId = setInterval(updateTimers, 1000);
});
